import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private authService = inject(AuthService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const auth = this.getAuthFromLocalStorage();
    const hasToken = !!auth?.token;
    const isExpired = auth?.expiresAtUtc
      ? Date.now() >= new Date(auth.expiresAtUtc).getTime()
      : true;

    if (!hasToken || isExpired) {
      this.authService.logout(state.url);
      return false;
    }

    return true;
  }

  private getAuthFromLocalStorage(): { token?: string; expiresAtUtc?: string } | null {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.endsWith('-auth')) {
        continue;
      }

      try {
        const raw = localStorage.getItem(key);
        if (!raw) {
          continue;
        }

        return JSON.parse(raw) as { token?: string; expiresAtUtc?: string };
      } catch {
      }
    }

    return null;
  }
}
